import Bugsnag from '@bugsnag/js';
import { ReactComponent as PlusIcon } from 'assets/heroicons/icon-plus.svg';
import Bank, { NoBank } from 'components/Admin/banks/Bank';
import PageMenu from 'components/PageMenu';
import { motion } from 'framer-motion';
import { useGetBanksQuery } from 'graphql/queries/GetBanks.generated';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useNavigate } from 'routeMap';

const Banks = () => {
  const [result] = useGetBanksQuery();
  const banks = result.data?.banks || [];
  const { path, url } = useRouteMatch();
  const navigate = useNavigate();

  if (result?.error) Bugsnag.notify(result?.error);

  return (
    <div className="relative flex flex-col w-full md:flex-row">
      <PageMenu
        base={url}
        items={banks?.map((bank) => ({
          to: `${url}/${bank?.id}`,
          label: bank?.name ?? 'Name Missing',
          // icon: BankIcon,
        }))}
      />
      <div className="absolute bottom-0 left-0 z-40 w-16 h-16 p-3 ml-48">
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          exit={{}}
          className="flex items-center justify-center w-full h-full text-3xl font-bold text-white rounded-full shadow bg-jcap-500 hover:bg-jcap-400 active:shadow-none"
          onClick={() => navigate.newBank()}
        >
          <PlusIcon className="w-10 h-10" />
        </motion.button>
      </div>

      <Switch>
        <Route exact path={`${path}/`}>
          <NoBank />
        </Route>
        {banks?.map((bank) => (
          <Route path={`${path}/${bank?.id}`} key={bank?.id}>
            <Bank id={bank?.id} />
          </Route>
        ))}
        <Route path={`${path}/new`}>
          <Bank id={null} />
        </Route>
      </Switch>
    </div>
  );
};

export default Banks;
